import { rootApi } from '../rootApi';

/**
 * LMS Rapor Maliyetleri — `/v1/LmsTrainingReportCost`.
 * Bkz. docs/LMS-Egitim-Raporlari-API.md §4.
 *
 * Bir eğitim raporunun maliyet satırları. `trainingReportId` ile rapora bağlanır;
 * `estimatedCost` ile `costSpent`'ten en az biri gönderilmelidir (doc §4.2).
 */
export const lmsTrainingReportCostApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsTrainingReportCosts: builder.query({
            query: ({ trainingReportId, currency, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsTrainingReportCost/GetList',
                method: 'POST',
                body: {
                    trainingReportId: trainingReportId ?? null,
                    currency: currency || null,
                    isActive: isActive !== undefined ? isActive : null,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsTrainingReportCost']
        }),

        getLmsTrainingReportCostById: builder.query({
            query: (id) => ({
                url: 'v1/LmsTrainingReportCost/GetById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsTrainingReportCost']
        }),

        addLmsTrainingReportCost: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTrainingReportCost/Add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTrainingReportCost']
        }),

        updateLmsTrainingReportCost: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTrainingReportCost/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTrainingReportCost']
        }),

        deleteLmsTrainingReportCost: builder.mutation({
            query: (id) => ({
                url: `v1/LmsTrainingReportCost/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['LmsTrainingReportCost']
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsTrainingReportCostsQuery,
    useGetLmsTrainingReportCostByIdQuery,
    useAddLmsTrainingReportCostMutation,
    useUpdateLmsTrainingReportCostMutation,
    useDeleteLmsTrainingReportCostMutation
} = lmsTrainingReportCostApi;
